export const OPEN_USER_PROFILE_MENU = 'OPEN_USER_PROFILE_MENU';

export function setUserProfileMenuOpenState(isOpen) {
  return {
    type: OPEN_USER_PROFILE_MENU,
    payload: isOpen,
  };
}



// WEBPACK FOOTER //
// ./app/features/layout/actions/setUserProfileMenu.js